'use strict';

var Actions = require('../actions/UserServerActionCreators'),
    UserStore = require('../stores/UserStore'),
    { get: get, patch, del, post } = require('../utils/APIUtils'),
    { pick } = require('underscore');

var UserAPI = {
  requestUser(userId) {
    var url = '/api/users/' + userId;
    get(url, Actions.handleUser, userId);
  },

  toggleServiceAccountHidden(serviceType, hidden) {
    var data = { hidden: hidden };
    patch('/api/user/services/' + serviceType, data, Actions.handleToggleServiceAccountHidden, serviceType);
  },

  disconnectServiceAccount(serviceType) {
    del('/api/user/services/' + serviceType, Actions.handleDisconnectServiceAccount, serviceType);
  },

  saveSettings(settings) {
    patch('/api/user', settings, Actions.handleSaveSettings);
  },

  requestResetPassword(data) {
    post('/api/user/reset-password', data, Actions.handleRequestResetPassword);
  },

  resetPassword(data) {
    patch('/api/user', data, Actions.handleResetPassword);
  },

  sendFeedback(data) {
    post('/api/feedback', data, Actions.handleFeedback);
  },

  resendUnconfirmedEmail() {
    post('/api/user/unconfirmed-email/resend', Actions.handleResendUnconfirmedEmail);
  },

  cancelUnconfirmedEmail() {
    del('/api/user/unconfirmed-email', Actions.handleCancelUnconfirmedEmail);
  },

  resubscribeEmail(data) {
    post('/api/user/resubscribe-email', data, Actions.handleResubscribeEmail);
  },

  saveEmailNotificationSettings() {
    var data = pick(UserStore.getMe(), 'emailFlags');
    patch('/api/user', data, Actions.handleSaveEmailNotificationSettings);
  },

  followUser(userId) {
    post('/api/users/' + userId + '/subscriptions', Actions.handleFollowUser, userId);
  },

  unfollowUser(userId) {
    del('/api/users/' + userId + '/subscriptions', Actions.handleUnfollowUser, userId);
  },

  requestUserSubscriberPage(userId, url) {
    url = url || '/api/users/' + userId + '/subscribers';
    get(url, Actions.handleUserSubscriberPage, userId);
  },

  requestUserSubscriptionPage(userId, url) {
    url = url || '/api/users/' + userId + '/subscriptions';
    get(url, Actions.handleUserSubscriptionPage, userId);
  },

  requestSearchPage(terms, url) {
    url = url || '/api/users/search?q=' + window.encodeURIComponent(terms);
    get(url, Actions.handleSearchPage, terms);
  }
};

module.exports = UserAPI;


/** WEBPACK FOOTER **
 ** ./api/UserAPI.js
 **/